import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import yellow from '@material-ui/core/colors/yellow';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Dropzone from 'react-dropzone';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

const styles = (theme) => ({
    dropzone: {
        padding: 10,
        borderWidth: 2,
        borderRadius: 4,
        borderStyle: 'dashed',
        borderColor: grey[200],
        textAlign: 'center',
    },
    error: {
        borderColor: red[500],
    },
    spacing: {
        margin: theme.spacing(2),
        height: '165px',
        width: '180px',
    },
    highlight: {
        backgroundColor: lighten(yellow[500], 0.8),
    },
    uploadMessage: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
});

class PhotoUpload extends React.Component {
    handleDelete = (event) => {
        this.props.onDelete(0);

        event.stopPropagation();
        event.preventDefault();
    };

    render() {
        return (
            <Grid container spacing={0} className={this.props.classes.spacing}>
                <Grid item xs={12}>
                    <Dropzone onDrop={this.props.onUpload} disabled={this.props.disabled}>
                        {({ getRootProps, getInputProps, isDragActive }) => (
                            <div
                                {...getRootProps({
                                    className: classNames(
                                        this.props.classes.dropzone,
                                        {
                                            [this.props.classes.error]: this.props.error,
                                        },
                                        {
                                            [this.props.classes.highlight]: isDragActive,
                                        },
                                    ),
                                })}
                            >
                                <input {...getInputProps()} />

                                <Grid item xs={12} className={this.props.classes.uploadMessage}>
                                    <CloudUploadIcon style={{ fontSize: 50 }} color="secondary" />
                                    <Typography color="textSecondary">
                                        Drag and drop a file or select the file.
                                    </Typography>
                                </Grid>
                            </div>
                        )}
                    </Dropzone>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(PhotoUpload);
